/**
 * Erkennung widerrufener Realtime-Database-Listen.
 *
 * Der Server widerruft einen offenen Listen, sobald das Token auf der Verbindung
 * kein Leserecht mehr traegt — bei jedem Auth-Wechsel (Login, Logout, Account-Merge)
 * und bei jeder Claim-Aenderung. Das ist kein Defekt, sondern der normale Weg, auf dem
 * eine Subscription endet; gemeldet gehoert es als `warn`, nicht als `error`
 * (ein `error` aus `NGXLogger` geht nach `/uilogging`).
 *
 * Bewusst framework-frei (kein Angular-Import), analog `lang-pref.ts`.
 */

/** firebase reports a revoked/denied listen as `permission_denied` (code) / "PERMISSION_DENIED" (message) */
export function isPermissionDenied(error: unknown): boolean {
    const code = String((error as { code?: string })?.code ?? '');
    const message = String((error as Error)?.message ?? error ?? '');
    return /permission.denied/i.test(code) || /permission.denied/i.test(message);
}
